import React from 'react';
import { cn } from '@/lib/utils';

interface LazyLoadingPlaceholderProps {
  height?: string;
  width?: string;
  className?: string;
  aspectRatio?: string;
}

/**
 * Placeholder de chargement lazy pour éviter les layout shifts (CLS)
 * Réserve l'espace avant le chargement du composant réel
 */
export const LazyLoadingPlaceholder: React.FC<LazyLoadingPlaceholderProps> = ({
  height = 'auto',
  width = '100%',
  className,
  aspectRatio
}) => {
  return (
    <div 
      className={cn(
        'loading-placeholder bg-gradient-to-r from-slate-800 via-slate-700 to-slate-800 animate-pulse rounded',
        className
      )}
      style={{
        height,
        width,
        aspectRatio,
        minHeight: height !== 'auto' ? height : '200px'
      }}
      aria-hidden="true"
      role="status"
      aria-label="Chargement en cours"
    >
      <span className="sr-only">Chargement...</span>
    </div>
  );
};

/**
 * Placeholder pour carte de serveur
 */
export const ServerCardPlaceholder: React.FC = () => {
  return (
    <div className="retro-card p-4 space-y-3" style={{ height: '192px' }}>
      <div className="flex items-center justify-between">
        <div className="h-6 w-16 bg-slate-700 rounded animate-pulse" />
        <div className="h-6 w-24 bg-slate-700 rounded animate-pulse" />
      </div>
      <div className="flex items-center gap-3">
        <div className="h-16 w-16 bg-slate-700 rounded animate-pulse" />
        <div className="flex-1 space-y-2">
          <div className="h-4 bg-slate-700 rounded w-3/4 animate-pulse" />
          <div className="h-3 bg-slate-700 rounded w-1/2 animate-pulse" />
        </div>
      </div>
      <div className="flex gap-2">
        <div className="h-6 w-20 bg-slate-700 rounded animate-pulse" />
        <div className="h-6 w-16 bg-slate-700 rounded animate-pulse" />
      </div>
    </div>
  );
};

/**
 * Placeholder pour grille de serveurs
 */
export const ServerGridPlaceholder: React.FC<{ count?: number }> = ({ count = 6 }) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <ServerCardPlaceholder key={index} />
      ))}
    </>
  );
};
